import soulSafariPoolImg from "@/assets/soul-safari-pool.webp";

import loungePoolImg from "@/assets/lounge-pool.webp";

const SoulSafariSection = () => {
  return (
    <section className="bg-background py-4 sm:py-6 lg:py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-0">
        <h2 className="font-heading text-2xl md:text-4xl tracking-wider text-foreground text-center mb-8">
          SOUL SAFARI
        </h2>
        {/* typography aligned with AboutSection */}

        {/* Pool sunset + Soul safari pool — stacked full-width images */}
        <div className="space-y-4 mb-12">
          <div className="overflow-hidden rounded">
            <img
              src={soulSafariPoolImg}
              alt="Soul Safari infinity pool at Zwahili"
              className="w-full h-72 md:h-96 object-cover"
              loading="lazy"
            />
          </div>
        </div>



        {/* Text block 2 */}
        <div className="max-w-5xl mx-auto text-center mb-16 space-y-2 text-sm text-muted-foreground leading-relaxed font-body">
          <p>
            Open-plan lounge & fully licensed bar blends contemporary comfort with authentic bush design, set to face sweeping panoramic views of the bush and the adjacent swimming pool. Sitting here everything seems to slow down.
          </p>
          <p>
            Natural stone walls, a high thatched roof create a grounded, earthy atmosphere. A sleek central bar is paired with elegant seating and a relaxed lounge area, inviting guests to unwind by the fire in winter and large open windows in summer with a cocktail in hand as the wilderness stretches out beyond the deck.
          </p>
          <p className="font-body font-medium mt-3 mb-0 text-accent text-sm">
            Worries feel smaller, thoughts less noisy. Quiet luxury meets immersion in nature.
          </p>
        </div>

        {/* Lounge pool + pool sunset — stacked images */}
        <div className="space-y-4 mb-12">
          <div className="overflow-hidden rounded">
            <img
              src={loungePoolImg}
              alt="Lounge overlooking pool"
              className="w-full h-72 md:h-96 object-cover"
              loading="lazy"
            />
          </div>
        </div>

        {/* Text block 3 */}
        <div className="max-w-5xl mx-auto text-center space-y-2 text-sm text-muted-foreground leading-relaxed font-body">
          <p>
            A front row seat to Africa. Quiet, calm & unhurried. Linger over coffee after breakfast watching the birds and the resident Nyala herds.
          </p>
          <p className="font-body font-medium mt-2 mb-0 text-accent text-sm">
            There is a gentle sense of ease in the air — the kind where your shoulders drop without you noticing.
          </p>
        </div>
      </div>
    </section>
  );
};

export default SoulSafariSection;
